import { Button, Link, Stack, Typography, useTheme } from '@mui/material'
import { useEffect, useEffectEvent, useState } from 'react'

import fetchWithAuth from '../../utilities/fetchWithAuth'

const TwoFactorAuthSetupCode = ({ onConfirm, previousCode, showAlert }) => {
  const theme = useTheme()
  const [keyCode, setKeyCode] = useState(previousCode.code ?? null)
  const [qrCode, setQrCode] = useState(previousCode.qrCode ?? null)

  const displayAlert = useEffectEvent(() => {
    showAlert({
      text: 'Could not get key code for 2FA. Try again later.',
      color: 'error',
    })
  })

  useEffect(() => {
    if (previousCode.code) return
    const getQR = async () => {
      try {
        const { data } = await fetchWithAuth('auth/2fa/setup')
        if (data) {
          setKeyCode(data.secret)
          setQrCode(data.qrCode)
        } else {
          displayAlert()
        }
      } catch (error) {
        displayAlert()
        console.error('Could not get code', error)
      }
    }
    getQR()
  }, [previousCode.code])

  return (
    <Stack
      sx={{
        gap: 4,
        direction: 'column',
        alignItems: 'center',
        width: '100%',
      }}
    >
      {keyCode && (
        <Stack
          sx={{
            backgroundColor: theme.palette.background.default,
            gap: 4,
            direction: 'column',
            width: '100%',
            alignItems: 'center',
            p: 2,
            borderRadius: theme.shape.borderRadius + 'px',
          }}
        >
          {qrCode && (
            <img
              src={qrCode}
              alt={keyCode}
              loading="lazy"
              width="150px"
              height="auto"
              style={{
                borderRadius: theme.shape.borderRadius,
                border: '1px solid ' + theme.palette.divider,
              }}
            />
          )}
          <Typography
            sx={{ width: '100%', textAlign: 'center' }}
            variant="body2"
          >
            {keyCode}
          </Typography>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => copyKeyCode()}
          >
            Copy Key Code
          </Button>
        </Stack>
      )}
      <Button
        variant="contained"
        color="primary"
        disabled={!keyCode}
        onClick={() => onConfirm({ code: keyCode, qrCode: qrCode })}
      >
        Continue{' '}
      </Button>
    </Stack>
  )
}

export default TwoFactorAuthSetupCode
